import { getMapStyles, APIKEY } from './maps-utilities';

const maps = {};

/**
 * Set markers and centerize map
 * @param {HTMLElement} mapElement mapElement object
 */
function setMarkersAndCenter(mapElement) {
  const map = maps[mapElement.id];
  const bounds = new window.google.maps.LatLngBounds();

  if (map.markers) {
    map.markers.forEach(marker => {
      marker.map = null;
    });
  }

  map.markers = [];

  if (map.markerData && map.markerData.length > 0) {
    map.markerData.forEach(marker => {
      const position = new window.google.maps.LatLng(marker.lat, marker.lon);

      // Create the advanced marker
      const gMarker = new window.google.maps.marker.AdvancedMarkerElement({
        position: position,
        map: map.map,
      });

      map.markers.push(gMarker);
      bounds.extend(position);
    });
  } else {
    const latlng = new window.google.maps.LatLng(60.169845, 24.938551); //show helsinki as default if there are no markers
    bounds.extend(latlng);
  }

  map.map.fitBounds(bounds);
}

/**
 * Initialize dynamic Google Map element
 * @param {HTMLElement} mapElement HTMLElement wrapped to jQuery object
 */
function initializeDynamicMap(mapElement) {
  const id = mapElement.id;

  maps[id] = {};
  maps[id].markerData = [];

  if (mapElement.dataset.coords !== '') {
    maps[mapElement.id].markerData.push({
      lat: mapElement.dataset.coords.split(';')[0],
      lon: mapElement.dataset.coords.split(';')[1],
    });
  }

  const mapOptions = {
    ...getMapStyles(),
    mapId: id
  };

  maps[mapElement.id].map = new window.google.maps.Map(mapElement, mapOptions);
  setMarkersAndCenter(mapElement);
}


/**
 * Initializes store page static maps
 */
function initStaticMaps() {

  document.querySelectorAll('.static-map').forEach(staticMapElement => {
    const imageElement = staticMapElement.querySelector('img');
    //After user click static map a dynamic map is loaded
    imageElement.addEventListener('click', () => {
      staticMapElement.classList.add('hidden');
      const parentElement = staticMapElement.parentElement;
      const dynamicMapElement = parentElement.querySelector('.dynamic-map');
      dynamicMapElement.classList.remove('hidden');
      initializeDynamicMap(dynamicMapElement);
    });
  });
}

/**
 * Global callback that is called by Google Map API callback function.
 */
window.mapApiLoaded = function() {
  document.querySelectorAll('.map-canvas').forEach(mapElement => {
    initializeDynamicMap(mapElement);
  });

  initStaticMaps();
};

/**
 * Inject external Javascript script to DOM. This is ment to replace $.getSscript() method used before this.
 *
 * @param {string} script script name
 */
function injectScript(script) {
  const scriptTag = document.createElement('script');
  scriptTag.src = script; // set the source of the script to your script
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag); // append the script to the DOM
}

export default {
  init: function() {
    const hasStaticMaps = document.querySelectorAll('.static-map').length > 0;

    if (document.body.classList.contains('google-map') || hasStaticMaps) {

      //When this script is fully loaded GoogleMaps calls window.mapApiLoaded callback.
      injectScript(`https://maps.googleapis.com/maps/api/js?key=${APIKEY}&libraries=geometry,marker&sensor=true&async=2&callback=mapApiLoaded`);
    }
  }
};
